import React, { useLayoutEffect, useRef } from 'react'
import '../components/pages/Portfolio/styles.css'
import proyects from '../components/pages/Portfolio/proyects.js'
import { getProjectVariables } from '../config/projectThemes'
import { useProjectTheme } from '../context/ProjectThemeContext'

import { Card, CardActions, CardActionArea, CardContent, CardMedia, Divider, Typography, IconButton, Stack } from '@mui/material'
import { Android, Apple, Download } from '@mui/icons-material';

const Portfolio = () => {
    const carouselRef = useRef(null)
    const { selectedProjectId, selectProject } = useProjectTheme()
    const activeProject = Math.max(0, proyects.findIndex((project) => project.class === selectedProjectId))
    const initialProject = useRef(activeProject)

    useLayoutEffect(() => {
        const carousel = carouselRef.current
        carousel.scrollTop = initialProject.current * carousel.clientHeight
    }, [])

    const handleScroll = (event) => {
        const { scrollTop, clientHeight } = event.currentTarget
        if (!clientHeight) return

        const index = Math.max(0, Math.min(proyects.length - 1, Math.round(scrollTop / clientHeight)))
        selectProject(proyects[index].class)
    }

    const goToProject = (index) => {
        const carousel = carouselRef.current

        if (carousel) {
            carousel.scrollTo({
                top: index * carousel.clientHeight,
                behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            })
        }
    }

    return (
        <div className='portfolio'>
            <div className='portfolio-carousel' role='region' aria-label='Proyectos del portafolio'
                tabIndex={0} ref={carouselRef} onScroll={handleScroll}>
                {proyects.map((proyect) => (
                    <section
                        key={proyect.name}
                        id={`portfolio-${proyect.class}`}
                        className='portfolio-slide'
                        style={getProjectVariables(proyect.class)}
                    >
                        <Card sx={{ maxWidth: 250, backgroundColor: 'transparent'}}>
                            <CardActionArea onClick={() => { window.open(proyect.web) }}>
                                <CardMedia component="img"  height="250" image={proyect.icon} alt={proyect.name} />
                                <CardContent>
                                    <Typography gutterBottom variant="h5">
                                        {proyect.name}
                                    </Typography>
                                    <Typography variant="body1">
                                        {proyect.description}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                            <CardActions>
                                <Stack direction="row" spacing={2}>
                                    { proyect.android &&
                                        <IconButton size="large" onClick={ () => window.open(proyect.android) }>
                                            <Android />
                                        </IconButton>
                                    }
                                    { proyect.ios &&
                                        <IconButton size="large" onClick={ () => window.open(proyect.ios) }>
                                            <Apple />
                                        </IconButton>
                                    }
                                    <Divider orientation="vertical" flexItem />
                                    <IconButton size="small" >
                                        {proyect.downloads}
                                        <Download />
                                    </IconButton>
                                </Stack>
                            </CardActions>
                        </Card>
                    </section>
                ))}
            </div>
            <nav className='portfolio-controls' aria-label='Seleccionar proyecto'>
                {proyects.map((proyect, index) => (
                    <button
                        key={proyect.name}
                        type='button'
                        className={`portfolio-dot${activeProject === index ? ' portfolio-dot-active' : ''}`}
                        aria-label={`Ver proyecto: ${proyect.name}`}
                        aria-controls={`portfolio-${proyect.class}`}
                        aria-current={activeProject === index ? 'true' : undefined}
                        title={proyect.name}
                        onClick={() => goToProject(index)}
                    >
                        <img src={proyect.icon} alt='' />
                    </button>
                ))}
            </nav>
        </div>
    )
}

export default Portfolio
